import Error from '../model/Error';
import axios from 'axios';

export default class PhysicalAccessRuleRepository {

    static find(id) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/physical-access-rules/${id}`)
                .then(response => resolve(response.data.data))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static findByClub(clubId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/physical-access/rules`)
                .then(response => resolve(response.data.data))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static create(id, rule) {
        return new Promise((resolve, reject) => {
            axios
                .post(`/club/clubs/${id}/physical-access/rules`, rule)
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static update(id, rule) {
        return new Promise((resolve, reject) => {
            axios
                .put(`/club/physical-access-rules/${id}`, rule)
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static remove(id) {
        return new Promise((resolve, reject) => {
            axios
                .delete(`/club/physical-access-rules/${id}`)
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }
}
